import Index from "../../pages/sakura/shake/index";

const base = "shake";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/sakura/shake.js